import { type CohortIguanaObject } from 'Cohorts';
import { type TranslationHelperInstance } from 'Translation';
import { type CurriculumStatus } from 'ProgramInclusion';
import { SidebarBoxKey, type SidebarBoxConfig } from '../StudentDashboard.types';
import { hideThisWeeksScheduleWatcher } from './scheduleHelpers';

type params = {
    translationHelper: TranslationHelperInstance;
    relevantCohort: CohortIguanaObject;
    curriculumStatus: CurriculumStatus | null;
};

const desktopContentTemplate = 'AdmissionsGuidance/thisWeekInSlackDesktop';

export const thisWeekInSlackConfig = ({
    translationHelper,
    relevantCohort,
    curriculumStatus,
}: params): SidebarBoxConfig => ({
    key: SidebarBoxKey.this_week_in_slack,
    heading: translationHelper.get('heading_slack'),
    scope: { curriculumStatus, relevantCohort, exercises: relevantCohort.currentPeriod?.exercises || [] },
    desktopContentTemplate,
    shouldHide: !relevantCohort.currentPeriod?.exercises?.length,
    watchers: {
        ...hideThisWeeksScheduleWatcher,
    },
});

export default thisWeekInSlackConfig;
